export default __webpack_public_path__ + "static/media/planetas-black.9f869525.svg";